import type { Dispatch, SetStateAction } from "react";
import type { INotification } from "libs/design-system/src/types/notification/notification";
import { Check, CircleExclamation, Xmark } from "@unified-checkout/design-system/icons/index";
import { onToasterShowHandler } from "@app/dashboard/utils/tracking/onToasterShowHandler";
import { SYSTEM_EVENTS_SRC_FEATURES } from "@app/dashboard/constants/tracking_events/system";

export const MAX_SM_NOTIFICATION_WIDTH = "25rem";
export const MAX_LG_NOTIFICATION_WIDTH = "40rem";
export const NOTIFICATION_TIMEOUT = 4;
export const MAX_EMAIL_LENGTH = 80;

export const handleToasterClose = (
  setToasterInfo: Dispatch<SetStateAction<{
    open: boolean,
    state: 'success' | 'error' | 'warning',
    text: string,
    hint: string,
    trackingCode?: string
  }>>) => {

  setToasterInfo((prevState) => ({
    ...prevState,
    open: false,
  }));
};

export const NotificationSharedProps = ({
  open,
  state,
  text,
  hint,
  onCloseHandler,
  onShowHandler,
}: {
  open: boolean,
  state: 'success' | 'error' | 'warning',
  text: string,
  hint?: string,
  onCloseHandler: () => void,
  onShowHandler?: () => void,
}): INotification => ({
  type: "notification",
  show: open,
  width: "fit-content",
  maxWidth: state === "warning" ? MAX_LG_NOTIFICATION_WIDTH : MAX_SM_NOTIFICATION_WIDTH,
  position: "fixed",
  placement: "top_end",
  state: state === 'error' ? 'danger' : state,
  title: text,
  hintText: hint,
  icon: state === "error" ? Xmark : state === "warning" ? CircleExclamation : Check,
  timeout: state === "warning" ? undefined : NOTIFICATION_TIMEOUT,
  hasCloseIcon: state === "warning",
  onCloseHandler,
  onShowHandler
});

export const getToasterConfig = ({
  type,
  msg,
  trackingCode,
  extra = {},
}: {
  type: 'success' | 'error';
  msg: string;
  trackingCode: string;
  extra?: Record<string, unknown>;
}) => ({
  timeout: NOTIFICATION_TIMEOUT,
  maxWidth: MAX_SM_NOTIFICATION_WIDTH,
  ...(type === 'error' && { icon: Xmark }),
  ...extra,
  onShowHandler: () =>
    onToasterShowHandler({
      type,
      trackingCode,
      msg: (msg || extra?.hintText) as string,
      srcFeature: SYSTEM_EVENTS_SRC_FEATURES.USERS_AND_PERMS,
    }),
});